module.exports = __webpack_public_path__ + "img/M2.60bb88f2.jpg";